import React, {useState} from 'react';

import PrivatePage from 'components/PrivatePage';
import Button from 'components/Button';
import DrivingSchools from 'components/DrivingSchools';
import Spinner from 'components/Spinner';
import useUser from 'hooks/useUser';
import useActions from 'hooks/useActions';
import {default as ProfileForm} from 'forms/Profile';
import {updateProfile, resetPassword} from 'actions';

const ResetPassword = ({email}) => {
  const dispatchResetPassword = useActions(resetPassword);
  const onReset = () => {
    dispatchResetPassword({email}, {onSuccess: () => console.log("reset password ok")})
  }
  const [reset, setReset] = useState(false);
  const onClick = () => {
    setReset(true);
    onReset()
  }
  return (
    <div className="box">
      <div className="content">
      <h4 className="title is-4">Changer votre mot de passe</h4>
      {!reset ?
      <p>Cliquer sur le bouton ci-dessous pour changer votre mot de passe. Un email vous sera envoyé</p>
        :
      <p>Un email vous a été envoyé pour changer votre mot de passe</p>
      }
      <Button className="button is-primary" onClick={onClick} disabled={reset}>
        Changer mon mot de passe
      </Button>
      </div>
    </div>
  )
}

const DrivingSchoolSection = ({drivingSchools}) => {
  return (
    <div className="content">
      <h4 className="title is-4">Vos auto-écoles</h4>
      <DrivingSchools drivingSchools={drivingSchools} />
    </div>
  )
}

const Profile = ({user}) => {
  const dispatchUpdateProfile = useActions(updateProfile);
  return (
  <div className="box">
    <h4 className="title is-4">Mes informations</h4>
    <ProfileForm user={user} onSubmit={(data) => dispatchUpdateProfile(data, {onSuccess: () => console.log("update profile ok")})}/>
  </div>
  )
}

const UserAccount = ({user}) => {
  const profile = user.user
  return (
    <div>
      <Profile user={profile}/>
      <hr />
      <DrivingSchoolSection drivingSchools={profile.driving_schools} />
      <hr />
      <ResetPassword email={profile.email} />
    </div>
  )
}

const Account = ({navbarProps}) => {
  const user = useUser();
  return (
    <PrivatePage navbarProps={navbarProps}>
      <div className="container">
        <h1 className="title is-1">
          Mon compte
        </h1>
        {user.isLoading ?
        <Spinner size="3x" />
        :
        <UserAccount user={user} />
        }
      </div>
    </PrivatePage>
  )
}

export default Account;